import React, {useEffect, useState} from 'react';
import colors from '../../../../../util/colors';
import './styles.scss';
import {Column, Row} from '../../../../../components/layout';
import * as fonts from '../../../../../util/fonts';
import {strings} from '../../../../../util/strings';
import {connect} from 'react-redux';
import {compose} from 'redux';
import * as Yup from 'yup';
import {useHistory} from 'react-router-dom';
import {
  addToGlobalStyles,
  addToWizard,
  setWizard,
} from '../../../../../store/actions';
import {
  AppForm,
  AppFormDatePickerField,
  AppFormSelectField,
  AppFormSubmitButton,
} from '../../../../../components/forms';
import {get, postWithCustomHeaders} from '../../../../../api/api';
import {
  uriGetProcedures,
  uriMemberData,
  uriSubmitPreAuthorization,
} from '../../../../../api/endpoints';
import AppFilePreview from '../../../../../components/app-drap-drop-file-input/app-file-preview';
import AppDrapDropFileInput from '../../../../../components/app-drap-drop-file-input';
import {recreateFilesFromRedux, toDataUrl} from '../../../../../util/utility';
import AppSpinner from '../../../../../components/app-spinner';
import AppErrorMessage from '../../../../../components/app-error-message';
import moment from 'moment';
import Icon from '../../../../../components/icon';
import {Icons} from '../../../../../util/icons';
import {
  IPreAuthorizationProcedure,
  IProcedureDetail,
} from '../../../PreAuthorizations';

export interface DataValidationProps {
  onSubmit(values: any): any;
  setValid(value: boolean): void;
  valid: boolean;
  wizard: any;
  selectedBu: any;
  language: any;
  setWizard(value: any): void;
  addToWizard(value: any): void;
  addToGlobalStyles(value: any): void;
  labels: typeof strings.pt.createRefund;
  labels_auth: typeof strings.pt.preAuthorizations;
  messageLabels: typeof strings.pt.messages;
  buStyles: any;
  user: any;
  patients: any;
}

function DataValidation(props: DataValidationProps) {
  const {
    labels,
    wizard,
    labels_auth,
    buStyles,
    messageLabels,
    user,
    patients,
    language,
  } = props;
  const [valid, setValid] = useState(false);
  const [sessionId, setSessionId] = useState<string>();
  const [patient, setPatient] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [patientOptions, setPatientOptions] = useState<any[]>([]);
  const [procedureOptions, setProcedureOptions] = useState<any[]>([]);
  const [formikContext, setFormikContext] = useState<any>();
  const [currentComment, setCurrentComment] = useState('');
  const history = useHistory();
  const [files, setFiles] = useState<any[]>([]);
  const [currentDateOfOcurrence, setCurrentDateOfOcurrence] = useState('');
  const [errorPost, setErrorPost] = useState(false);
  const [hoverErrorIcons, setHoverErrorIcons] = useState(false);
  const [isEmptyFiles, setIsEmptyFiles] = useState(files.length <= 0);

  const featureName = 'PreAuthorizations-DataValidation';

  const [validationSchema, setValidationSchema] = useState<any>(
    Yup.object().shape({
      proceed: Yup.mixed().required(),
    })
  );

  if (!!wizard.attachFiles && !!!sessionId) {
    setSessionId(wizard.attachFiles.sessionId);
  }

  const onDelete = (id: string) => {
    let newFiles = [...files];
    newFiles = newFiles.filter((elem) => {
      if (elem.id !== id) {
        return true;
      } else {
        URL.revokeObjectURL(elem.preview);
        return false;
      }
    });
    setFiles(newFiles);

    setIsEmptyFiles(newFiles.length <= 0);
  };

  const onFileAdd = (addedFiles: any[]) => {
    setIsEmptyFiles(false);
  };

  const handleComment = (event: any) => {
    setCurrentComment(event.target.value);
  };

  const defineOnMouseFunctions = (e: React.MouseEvent) => {
    var elem: HTMLElement = e.target as HTMLElement;

    if (elem.tagName.includes('svg') || elem.tagName.includes('path')) {
      var icon: HTMLElement = elem as HTMLElement;

      if (icon) {
        icon.onmouseover = function () {
          setHoverErrorIcons(true);
        };
        icon.onmouseout = function () {
          setHoverErrorIcons(false);
        };
      }
    }
  };

  function getPatientOptions() {
    const patients = props.patients.patients;

    setPatientOptions(
      (patients as any)?.map((patient: any) => ({
        value: patient.memId,
        label: patient.memberName,
      }))
    );
  }

  async function getProceedOptions() {
    const seen = new Set();
    const proceeds: any = await get(
      uriGetProcedures(props.selectedBu.buId),
      false,
      0,
      featureName
    );

    const filteredProceeds = (proceeds?.data?.items as any[]).filter(
      (proceed) => {
        return proceed.status === 'ACTIVE';
      }
    );

    let proceduresAux: any = [];
    (filteredProceeds as any)?.forEach((item: IPreAuthorizationProcedure) => {
      const detail: IProcedureDetail | undefined =
        item.buPreAuthProcedureDetails.find(
          (det: IProcedureDetail) => det.languageAlias === language
        );
      if (detail && detail.preAuthProcedureAlias && detail.frontendTitle) {
        proceduresAux.push({
          value: detail.serviceGroup,
          label: detail.frontendTitle,
        });
      }
    });

    setProcedureOptions(proceduresAux);
  }

  const onDateOfOcurrenceChange = (value: any) => {
    if (value) {
      setCurrentDateOfOcurrence(value);
    } else {
      setCurrentDateOfOcurrence('');
    }
  };

  const setPreviousStepsData = () => {
    const {files: reduxFiles} = props.wizard.attachFiles;
    const newFiles = recreateFilesFromRedux(reduxFiles);
    const downloadBlobs =
      history.location && history.location.state && history.location.state;
    if (downloadBlobs) {
      newFiles.forEach((file: any) => {
        toDataUrl(file.preview, (base64: any) => {
          const files = [...newFiles];
          const newFile = {...file, preview: base64};
          files[files.indexOf(file)] = newFile;
          setFiles(files);
          setIsEmptyFiles(files.length <= 0);
        });
      });
    } else {
      setFiles(newFiles);
      setIsEmptyFiles(newFiles.length <= 0);
    }
    getPatientOptions();
    setPatient(patients.memId);
    getProceedOptions();
  };

  const onSubmit = async (values: any) => {
    setSubmitting(true);
    const {buId, famId, grpId, benNbr} = props.patients;
    const selectedContact: any = await get(uriMemberData(buId, patient, famId));
    var formData = new FormData();
    props.addToWizard({
      attachFiles: {
        sessionId: sessionId,
        files: files,
      },
    });
    formData.append(
      'user',
      user.value.given_name + ' ' + user.value.family_name
    );
    formData.append('buId', selectedContact.buId);
    formData.append('memId', selectedContact.memId);
    formData.append('email', user.value.email);
    formData.append('beneficiary', benNbr);
    formData.append('phone', user.value.phone_number);
    formData.append('name', selectedContact.name);
    formData.append('multicode', props.selectedBu.multicode);
    formData.append('usesMulticode', props.selectedBu.usesMulticode);
    formData.append('buName', props.selectedBu.buName);
    formData.append('procedure', values.proceed);
    formData.append(
      'procedureDate',
      moment(values.currentDateOfOcurrence).add(1, 'hours').format()
    ); //acrescenta mais 1h para o dia não estar errado devido a timezone utc
    formData.append('comments', currentComment);
    files.forEach((doc) => {
      formData.append('documents', doc.file);
    });
    formData.append('groupId', grpId);

    try {
      const response: any = await postWithCustomHeaders(
        uriSubmitPreAuthorization(),
        formData
      );
      if (response.result.status === 'Success') {
        const data = {
          patient: selectedContact.name,
          proceed: values.proceed,
          date: moment(values.currentDateOfOcurrence).add(1, 'hours').format(),
          submissionTime: moment().format('HH:mm'),
        };
        history.push('/pre-autorizacoes/pedido-enviado', data);
      } else {
        setErrorPost(true);
      }
    } catch (e) {
      setErrorPost(true);
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    setPreviousStepsData();
  }, []);

  useEffect(() => {
    setPreviousStepsData();
  }, [wizard]);

  return (
    <div className="reimbersement-data-container">
      <AppForm
        className="patient-validation-form-container pre-authorization-container-form"
        initialValues={{
          currentDateOfOcurrence: '',
          noDocuments: false,
          proceed: '',
        }}
        validationSchema={validationSchema}
        onValidation={(valid: boolean) => setValid(valid)}
        onSubmit={async (values) => onSubmit(values)}>
        {!submitting && (
          <Row className="reimbursement-confirm-data">
            <p
              style={{
                ...fonts.ML,
                ...fonts.Bold,
                color: colors.black,
              }}
              className="reimbursement-data-subtitle-desktop">
              {labels?.createRefund_confirmData}
            </p>
            <p
              style={{
                ...fonts.ML,
                ...fonts.Bold,
                color: colors.black,
              }}
              className="reimbursement-data-subtitle-responsive">
              {labels?.createRefund_confirmDataResponsive}
            </p>
          </Row>
        )}
        {!submitting && (
          <div className="grid-container patient-row">
            <Column
              className="reimbursement-data-firstrow-column pre-authorization-column"
              style={{
                background: 'linear-gradient(180deg, #F9F9F9 0%, #F0F0F0 100%)',
              }}>
              <Row className="reimbursement-data-firstrow-column-firstrow">
                <p style={{...fonts.SM}}>{labels?.createRefund_patient}*</p>
              </Row>
              <Row>
                <AppFormSelectField
                  className="reimbursement-data-input w-100"
                  name={'patient'}
                  inputStyle={{
                    ...fonts.Bold,
                    color: buStyles?.primaryColor || colors.blue,
                  }}
                  options={patientOptions}
                  value={patient}
                  onChange={(value) => {
                    setPatient(value);
                  }}
                  handleFormikContext={(formik) => {
                    if (!!!formikContext) {
                      setFormikContext(formik);
                    }
                  }}></AppFormSelectField>
              </Row>
            </Column>
            {files?.map((item: any) => (
              <Column
                className="reimbursement-data-firstrow-column reimbursement-data-file-preview pre-authorization-files pre-authorization-column"
                style={{
                  background:
                    'linear-gradient(180deg, #F9F9F9 0%, #F0F0F0 100%)',
                }}>
                <div className="app-drag-drop-preview-responsive pre-authorization-preview">
                  <AppFilePreview
                    displayQuantity={true}
                    name={item.name}
                    deleteAll
                    file={item}
                    files={[item]}
                    onDelete={() => onDelete(item.id)}
                    scope="preAuthorizations"
                  />
                </div>
              </Column>
            ))}
          </div>
        )}
        {!submitting && (
          <>
            <Row
              className="pre-authorization-data-row"
              style={{
                background: 'linear-gradient(180deg, #F9F9F9 0%, #F0F0F0 100%)',
              }}>
              <Column className="pre-authorization-data-row-left-column">
                <Column>
                  <Row className="reimbursement-data-firstrow-column-firstrow">
                    <p style={{...fonts.SM}}>
                      {labels_auth.authorization_procedure}*
                    </p>
                  </Row>
                  <Row>
                    <AppFormSelectField
                      className="reimbursement-data-input-procedure w-100"
                      name={'proceed'}
                      options={procedureOptions}></AppFormSelectField>
                  </Row>
                </Column>
                <Column>
                  <Row className="reimbursement-data-firstrow-column-firstrow">
                    <p style={{...fonts.SM}}>
                      {labels_auth.authorization_procedureDate}*
                    </p>
                  </Row>
                  <Row className="date-picker-row">
                    <AppFormDatePickerField
                      className="reimbursement-data-input"
                      name={'currentDateOfOcurrence'}
                      onChange={(value: any) => onDateOfOcurrenceChange(value)}
                      placeholder={
                        labels_auth.authorization_procedureDatePlaceholder
                      }
                      value={currentDateOfOcurrence}></AppFormDatePickerField>
                    {hoverErrorIcons && (
                      <AppErrorMessage
                        message={
                          currentDateOfOcurrence === ''
                            ? messageLabels?.requiredField
                            : messageLabels.invalidDate
                        }
                        className="data-validation-pop-up-error-message"
                      />
                    )}
                    {currentDateOfOcurrence === '' && (
                      <Icon
                        onMouseOver={(e) => defineOnMouseFunctions(e)}
                        width="24"
                        height="24"
                        className="date-picker-error-icon"
                        name={Icons.ALERT_PROBLEM}
                        color={colors.alertRed}
                      />
                    )}
                  </Row>
                </Column>
              </Column>
              <Column className="pre-authorization-data-row-right-column">
                <Column>
                  <Row className="reimbursement-data-firstrow-column-firstrow">
                    <p style={{...fonts.SM}}>
                      {labels_auth.authorization_comments}
                    </p>
                  </Row>
                  <Row>
                    <textarea
                      style={{...fonts.M}}
                      className="reimbursement-comments-notes-input"
                      name="commentsNotes"
                      placeholder={labels_auth.preAuthorizations_insertComments}
                      value={currentComment}
                      onChange={handleComment}></textarea>
                  </Row>
                </Column>
              </Column>
            </Row>

            <Row className="upload-file-container">
              <AppDrapDropFileInput
                preAuth={true}
                files={files}
                setFiles={setFiles}
                newFilesName={labels?.createRefund_invoice}
                onFileAdd={onFileAdd}
                filesSizeLimit={true}
                hidePreviews={true}
              />
            </Row>
          </>
        )}
        {!submitting && (
          <Row className="pre-authorization-data-obligatory-fields">
            <p style={{...fonts.SM}}>
              {labels_auth.authorization_obligatoryFields}
            </p>
          </Row>
        )}
        {!submitting && (
          <Row className="attach-files-confirm-button-row pre-authorization-button">
            <AppFormSubmitButton
              className="attach-files-confirm-button"
              title={labels_auth.authorization_send}
              disabled={
                !valid ||
                submitting ||
                isEmptyFiles ||
                currentDateOfOcurrence === ''
              }
            />
          </Row>
        )}
        {submitting && <AppSpinner />}
        {errorPost && (
          <Row className="justify-content-center">
            <label style={{color: colors.alertRed}}>
              {labels_auth.authorization_occurredAnError}
            </label>
          </Row>
        )}
      </AppForm>
    </div>
  );
}

const mapStateToProps = ({
  selectedBu,
  language,
  wizard,
  strings,
  globalStyles,
  user,
  patients,
}: any) => ({
  selectedBu: selectedBu.value,
  language: language.value,
  wizard: wizard.value,
  labels: strings.value.pt.createRefund,
  labels_auth: strings.value.pt.preAuthorizations,
  buStyles: globalStyles.value,
  messageLabels: strings.value.pt.messages,
  patients: patients.value,
  user,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(DataValidation)
);
